export default function PrivacyPolicyPage() {
  return (
    <div className="flex flex-col justify-start w-full py-10 px-5 gap-2 pb-32">
      <h1 className="text-4xl font-bold">Privacy Policy</h1>
      <div className="space-y-4">
        <p>
          ManUp (“we”, “us”, or “our”) respects your privacy. This Privacy
          Policy explains how we collect, use, and share information when you
          use our mobile app, website, or any associated services (collectively,
          the “Service”).
        </p>

        <h2 className="text-2xl font-semibold">1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul className="list-disc list-inside">
          <li>
            <strong>Personal Information:</strong> such as your email address if
            you sign up, subscribe, or contact us.
          </li>
          <li>
            <strong>Usage Data:</strong> information about how you use the app
            (e.g. scenarios played, decisions made, timestamps).
          </li>
          <li>
            <strong>Device Information:</strong> including device type,
            operating system, and browser type.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold">
          2. How We Use Your Information
        </h2>
        <p>We use your data to:</p>
        <ul className="list-disc list-inside">
          <li>Operate and improve the Game.</li>
          <li>Personalize your experience.</li>
          <li>Provide customer support and respond to inquiries.</li>
          <li>Send updates or promotional content (only if you opt in).</li>
        </ul>

        <h2 className="text-2xl font-semibold">3. Data Sharing</h2>
        <p>We do not sell your data. We may share your information with:</p>
        <ul className="list-disc list-inside">
          <li>
            Service providers (e.g. payment processors or analytics tools).
          </li>
          <li>
            Law enforcement if required by law or to protect rights and safety.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold">4. Data Retention</h2>
        <p>
          We retain your data as long as necessary to provide our services or
          comply with legal obligations. You may request deletion at any time.
        </p>

        <h2 className="text-2xl font-semibold">5. Your Rights</h2>
        <p>
          You may have the right to access, update, or delete your personal
          data. Contact us if you’d like to exercise these rights.
        </p>

        <h2 className="text-2xl font-semibold">6. Cookies & Tracking</h2>
        <p>
          We may use cookies or similar technologies to track user behavior on
          the web version of the Game for analytics and optimization.
        </p>

        <h2 className="text-2xl font-semibold">7. Security</h2>
        <p>
          We implement reasonable measures to protect your information, but no
          system is 100% secure.
        </p>

        <h2 className="text-2xl font-semibold">8. Children’s Privacy</h2>
        <p>
          The Service is not intended for users under 13. We do not knowingly
          collect personal information from children.
        </p>

        <h2 className="text-2xl font-semibold">9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We’ll notify you
          of any material changes by updating the effective date and posting a
          notice in the app or on the website.
        </p>

        <h2 className="text-2xl font-semibold">10. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, contact us at:
        </p>
        <a href="mailto:support@manupgame.com" className="underline">
          support@manupgame.com
        </a>
      </div>
    </div>
  );
}
